import {deserializeAs} from 'cerialize';
import {Pce} from './Pce';
import {DonneesTechniques} from './DonneesTechniques';

export class UsagePoint {

  @deserializeAs(Pce, 'pce')
  pce: Pce;

  @deserializeAs(DonneesTechniques, 'donnees_techniques')
  donneesTechniques: DonneesTechniques;

  @deserializeAs('statut_restitution')
  statutRestitution: string;
}
